import index from "./nitofications.vue";
export default index;
